import { Program, StandardLP } from "@/services/types";
import { formatStringArray } from "@/utils/Functions";
import { setItem } from "@/utils/Functions/storageUtils";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import GSIconVideo from "../../../../../public/images/new/GS-Icon-Video.svg";
import { routeVariables } from "@/utils/routestrings";
import { sanitizeUrlSegment } from "@/utils/routestrings";
function SlideWorkshop({
  learner,
  program
}: {
  learner: Program;
  program: StandardLP;
}) {
  const pathName = usePathname();
  return <Link href={`/in/${sanitizeUrlSegment(program?.attributes.name)}${routeVariables.PREMIUMCOURSE[2]}${program?.attributes.productId}`} className="section__programs-slider-card anchor-card" onClick={() => {
    setItem("Program Name", program?.attributes.name);
    setItem("Program Type", learner?.programType);
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
        event_label: "Click event on Self-Paced program",
        page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
      });
    }
  }} data-sentry-element="Link" data-sentry-component="SlideWorkshop" data-sentry-source-file="SlideWorkshop.tsx">
      <div style={{
      color: "inherit",
      textDecoration: "none"
    }} className="">
        <div className="section__programs-slider-card-container">
          <div className="section__programs-slider-card-header">
            <h3>{program?.attributes.name}</h3>
            <div className="section__programs-slider-card-stats">
              <div className="section__programs-slider-card-stats-item">
                <div className="section__programs-slider-card-stats-item-icon">
                  <Image width={17} height={17} src={GSIconVideo} alt="GSIconVideo" loading="lazy" data-sentry-element="Image" data-sentry-source-file="SlideWorkshop.tsx" />
                </div>
                <p>{learner?.duration}</p>
              </div>
            </div>
            {learner?.pricingProfile && (learner?.pricingProfile?.maxRetailPrice || learner?.pricingProfile?.discount) && <div className="section__programs-slider-card-header-price">
                ₹ {(learner?.pricingProfile?.maxRetailPrice || 0) - (learner?.pricingProfile?.discount || 0)}
              </div>}
          </div>

          {program.attributes.premium_mentors.data.length > 0 && <div className="section__programs-slider-slide-footer">
              <div className="section__programs-slider-slide-footer-images">
                {program.attributes.premium_mentors.data.map((mentor, index) => <div className="section__programs-slider-slide-footer-images-img" key={index}>
                      <Image src={mentor.attributes.mentorImage.data?.attributes.url || ""} alt="profilePhoto" width={40} height={40} className="" loading="lazy" />
                    </div>)}
                {program.attributes.premium_mentors.data.length > 3 && <div className="section__programs-slider-slide-footer-images-img">
                    +{program.attributes.premium_mentors.data.length - 3}
                  </div>}
              </div>
              {program.attributes.premium_mentors.data.length > 1 ? <p>
                  Multiple mentors from{" "}
                  <span>
                    {formatStringArray(program.attributes.premium_mentors.data.map(mentor => mentor.attributes.companyName))}
                  </span>
                </p> : <p>
                  {program.attributes.premium_mentors.data[0]?.attributes?.name}{" "}
                  <span>
                    {program.attributes.premium_mentors.data[0]?.attributes?.designation}
                    {program.attributes.premium_mentors.data[0]?.attributes?.companyName && `, ${program.attributes.premium_mentors.data[0]?.attributes?.companyName}`}
                  </span>
                </p>}
            </div>}
        </div>
      </div>
    </Link>;
}
export default SlideWorkshop;